'use client'

import { useIsDesktop } from '@/_hooks/useBreakpoint'
import { Center, HStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import {
  PaginationItems,
  PaginationNextTrigger,
  PaginationPrevTrigger,
  PaginationRoot,
} from '@/components/ui/pagination'
import { useRouter } from '@/i18n/navigation'
import { useSearchParams } from 'next/navigation'
import Desktop from './responsive/desktop'
import Mobile from './responsive/mobile'
import { FEATURED_BRANDS } from '@/_utils/Constants'
import recipeService from '@/_service/recipe.service'
import { useQuery } from '@tanstack/react-query'
import { IRecipe } from '@/_types'

const PAGE_SIZE = 12

const RecipesPage = ({
  initialData,
}: {
  initialData?: { recipes: IRecipe[]; count: string } | null
}) => {
  const [activeBrandId, setActiveBrandId] = useState<string>(
    () => FEATURED_BRANDS.yaponamama
  )

  const searchParams = useSearchParams()
  const router = useRouter()
  const page = searchParams.get('page')
  const isDesktop = useIsDesktop()

  const { data, isLoading } = useQuery({
    queryKey: ['recipes', activeBrandId, Number(page) || 1],
    queryFn: () =>
      recipeService
        .getList(
          { page: Number(page) || 1, limit: PAGE_SIZE },
          activeBrandId
        )
        .then((res) => res.data),
    initialData:
      activeBrandId === FEATURED_BRANDS.yaponamama && (!page || page === '1')
        ? initialData ?? undefined
        : undefined,
  })

  return (
    <>
      {isDesktop ? (
        <Desktop
          data={data?.recipes}
          isLoading={isLoading}
          activeBrandId={activeBrandId}
          setActiveBrandId={setActiveBrandId}
        />
      ) : (
        <Mobile
          data={data?.recipes}
          isLoading={isLoading}
          activeBrandId={activeBrandId}
          setActiveBrandId={setActiveBrandId}
        />
      )}
      {Number(data?.count) > PAGE_SIZE && (
        <Center my={4}>
          <PaginationRoot
            count={Number(data?.count)}
            pageSize={PAGE_SIZE}
            defaultPage={1}
            page={Number(page) || 1}
            onPageChange={(e) => router.push(`?page=${e.page}`)}
            variant='subtle'
          >
            <HStack>
              <PaginationPrevTrigger />
              <PaginationItems />
              <PaginationNextTrigger />
            </HStack>
          </PaginationRoot>
        </Center>
      )}
    </>
  )
}

export default RecipesPage
